<template>
    <div class="diagram-container">
        <div class="background-svg" v-html="backgroundSvg"></div>
        <div class="content-wrapper">
            <div class="box box-neurotoxicos" style="z-index: 10; pointer-events: auto;">
                <IndicatorCard title="Neurotóxicos" :count="totalNeurotoxic || 0" @chart-info-click="handleChartInfo"
                    chartKey="neurotoxic" :isLoading="isLoadingIndicatorCard['neurotoxic']" />
            </div>

            <div class="branches-container">
                <!-- Left branch -->
                <div class="branch left-branch">
                    <div class="box box-lesiones">
                        <IndicatorCard title="Lesiones Oculares" :count="totalOcularLesions || 0"
                            @chart-info-click="handleChartInfo" chartKey="ocular_lesions"
                            :isLoading="isLoadingIndicatorCard['ocular_lesions']" />
                    </div>

                    <div class="box box-afectaciones">
                        <IndicatorCard title="Irritación de vías Respiratorias" :count="totalRespiratoryAffectations || 0"
                            @chart-info-click="handleChartInfo" chartKey="respiratory_affectations"
                            :isLoading="isLoadingIndicatorCard['respiratory_affectations']" />
                    </div>

                    <div class="box box-toxicidad">
                        <IndicatorCard title="Corrosión cutánea" :count="totalProductCorrosveDermal || 0"
                            @chart-info-click="handleChartInfo" chartKey="corrosive_dermal"
                            :isLoading="isLoadingIndicatorCard['corrosive_dermal']" />
                    </div>

                    <div class="box box-reproductivos">
                        <IndicatorCard title="Toxicidad para la reproducción" :count="totalProductReproductiveOrgans || 0"
                            @chart-info-click="handleChartInfo" chartKey="reproductive_organs"
                            :isLoading="isLoadingIndicatorCard['reproductive_organs']" />
                    </div>
                </div>

                <!-- Right branch -->
                <div class="branch right-branch">
                    <div class="box box-ototoxicos">
                        <IndicatorCard title="Ototóxicos" :count="totalOtotoxic || 0" @chart-info-click="handleChartInfo"
                            chartKey="otoxicity" :isLoading="isLoadingIndicatorCard['otoxicity']" />
                    </div>

                    <div class="box box-ingestion">
                        <IndicatorCard title="Peligro por aspiración" :count="totalSGAAspirationHazard || 0"
                            @chart-info-click="handleChartInfo" chartKey="aspiration_hazard"
                            :isLoading="isLoadingIndicatorCard['aspiration_hazard']" />
                    </div>

                    <div class="box box-mutagen">
                        <IndicatorCard title="Mutagenicidad en células germinales" :count="totalMutagenicity || 0"
                            @chart-info-click="handleChartInfo" chartKey="mutagenicity"
                            :isLoading="isLoadingIndicatorCard['mutagenicity']" />
                    </div>

                    <div class="box box-irritacion">
                        <IndicatorCard title="Irritación Cutánea" :count="totalIrritationCutaneous || 0"
                            @chart-info-click="handleChartInfo" chartKey="cutaneous_irritation"
                            :isLoading="isLoadingIndicatorCard['cutaneous_irritation']" />
                    </div>
                </div>
            </div>
        </div>
        <ProductListModal :modal-id="'products-modal-the-body'" :title="modalTitle" :products="selectedProducts" :keyProduct="keyProducts"/>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import IndicatorCard from './IndicatorCard.vue';
import ProductListModal from "../ProductListModal.vue";

export default {
    name: 'ToxicityDiagram',
    components: {
        IndicatorCard,
        ProductListModal
    },
    data() {
        return {
            backgroundSvg: `<svg width="100%" height="100%" viewBox="0 0 696 712" preserveAspectRatio="xMidYMid meet" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M347.999 15L326.832 15C308.432 15 290.493 20.75 275.521 31.4461V31.4461C257.931 44.0129 245.565 62.598 240.767 83.6767L233.524 115.497C230.34 129.485 230.203 143.996 233.123 158.042L237.29 178.089C240.956 195.729 251.371 211.238 266.312 221.308L271.074 224.518C286.173 234.694 295.575 251.408 296.432 269.596V269.596C297.673 295.914 280.907 319.722 255.711 327.424L240.35 332.119C236.632 333.255 232.835 334.113 228.99 334.686L187.118 340.918C172.499 343.094 158.377 348.595 146.09 356.81V356.81C127.006 369.57 112.63 388.685 105.858 410.621L102.425 421.743C98.7101 433.777 97.302 446.405 98.2747 458.962L101.11 495.564C102.273 510.57 100.033 525.645 94.5576 539.665L80.6202 575.353C77.5378 583.246 75.4711 591.499 74.4697 599.913L59.9994 721.5L59.9994 804.5L52.8714 876.572C51.6554 888.867 46.5357 900.45 38.2617 909.625L28.3677 920.597C12.8618 937.791 13.8855 964.211 30.6754 980.155L32.2065 981.608C47.7945 996.41 72.2349 996.443 87.862 981.682V981.682C97.293 972.774 101.882 959.884 100.201 947.021L99.0389 938.121C97.5795 926.949 99.4028 915.593 104.286 905.439L130.119 851.726C134.022 843.612 136.81 835.009 138.41 826.15L148.992 767.531C150.919 756.86 151.097 745.947 149.52 735.22L147.537 721.733C145.832 710.135 146.179 698.328 148.564 686.85L168.885 589.021C169.131 587.838 169.508 586.685 170.008 585.585V585.585C176.755 570.766 198.67 573.922 200.961 590.043L201.591 594.478C201.726 595.427 201.938 596.364 202.225 597.278L215.676 640.089L229.819 674.751C233.103 682.798 235.323 691.24 236.424 699.861L240.401 730.999C242.121 744.471 241.08 758.152 237.339 771.208L201.456 896.459C183.15 960.356 231.121 1024 297.588 1024L348 1024" stroke="#36BEB8" stroke-width="30"/>
          <path d="M348.001 15L369.239 15C387.64 15 405.582 20.7441 420.562 31.4307V31.4307C438.19 44.007 450.587 62.6182 455.4 83.7314L462.634 115.468C465.827 129.475 465.964 144.006 463.036 158.071L458.874 178.066C455.199 195.72 444.768 211.238 429.808 221.306L425.016 224.531C409.909 234.698 400.5 251.411 399.641 269.6V269.6C398.399 295.913 415.167 319.715 440.361 327.405L455.814 332.122C459.531 333.256 463.327 334.113 467.172 334.684L509.168 340.926C523.773 343.097 537.715 348.474 549.995 356.673L550.481 356.998C569.581 369.75 583.71 388.689 590.493 410.63L593.921 421.72C597.646 433.769 599.058 446.414 598.082 458.988L595.247 495.533C594.081 510.559 596.327 525.654 601.817 539.69L615.759 575.34C618.849 583.242 620.921 591.504 621.925 599.929L636.414 721.5L636.414 804.5L643.552 876.567C644.77 888.865 649.896 900.449 658.179 909.62L668.049 920.549C683.595 937.763 682.569 964.236 665.738 980.195L664.223 981.632C648.62 996.427 624.178 996.459 608.537 981.706V981.706C599.078 972.784 594.475 959.865 596.161 946.972L597.319 938.124C598.78 926.951 596.954 915.593 592.065 905.441L566.199 851.737C562.288 843.616 559.492 835.004 557.889 826.135L547.298 767.553C545.366 756.868 545.187 745.94 546.769 735.197L548.748 721.758C550.457 710.144 550.109 698.32 547.718 686.827L527.373 589.026C527.127 587.839 526.748 586.684 526.246 585.581V585.581C519.483 570.748 497.546 573.911 495.25 590.051L494.62 594.475C494.485 595.426 494.272 596.365 493.983 597.282L480.514 640.089L466.356 674.738C463.064 682.794 460.838 691.245 459.734 699.877L455.757 730.97C454.032 744.46 455.077 758.161 458.827 771.234L494.744 896.422C513.079 960.328 465.106 1024 398.622 1024L348 1024" stroke="#36BEB8" stroke-width="30"/>
        </svg>`,
            modalTitle: '',
            selectedProducts: [],
            isLoadingIndicatorCard: {},
            keyProducts: null
        }
    },
    computed: {
        ...mapState("dashboard", ["dataDash1", "dataDash2", "dashboardFilters", "productsDashAffected"]),

        totalNeurotoxic() {
            return this.dataDash2.product_neurotoxic_count
        },
        totalOcularLesions() {
            return this.dataDash2.product_corrosive_ocular_count
        },
        totalRespiratoryAffectations() {
            return this.dataDash2.total_sga_target_organs_irritation_respiratory_count
        },
        totalOtotoxic() {
            return this.dataDash2.product_ototoxic_count
        },
        totalIngestion() {
            return this.dataDash2.oralcategory1_count + this.dataDash2.oralcategory2_count;
        },
        totalMutagenicity() {
            return this.dataDash2.total_sga_mutagenic_count
        },
        totalIrritationCutaneous() {
            return this.dataDash2.total_sga_irritants_dermal_count
        },
        totalProductTargetOrgans() {
            return this.dataDash2.product_target_organs_count
        },
        totalProductReproductiveOrgans() {
            return this.dataDash2.product_reproductive_organs_count
        },
        totalSGAAspirationHazard() {
            return this.dataDash2.total_sga_aspiration_hazard_count
        },
        totalProductCorrosveDermal() {
            return this.dataDash2.total_sga_corrosive_dermal_count
        }
    },
    methods: {
        ...mapActions("dashboard", ["findDataProducts"]),
        ...mapMutations("dashboard", ["resetProductsDashAffected"]),
        async handleChartInfo({ key, title }) {
            this.keyProducts = key;
            this.$set(this.isLoadingIndicatorCard, key, true);
            this.modalTitle = title;
            this.resetProductsDashAffected();

            try {
                const filters = {
                    ...this.dashboardFilters,
                    affectation: key,
                };
                await this.findDataProducts(filters);
                this.selectedProducts = this.productsDashAffected;
                this.$bvModal.show('products-modal-the-body');
            } catch (error) {
                console.error('Error al cargar los productos:', error);
            }
            finally {
                this.$set(this.isLoadingIndicatorCard, key, false);
            }
        }
    }
}
</script>

<style scoped>
.diagram-container {
    position: relative;
    width: 100%;
    max-width: 696px;
    /* límite máximo de ancho, como ya hacías */
    margin: 0 auto;
    /* centrado horizontal */
}

/* Este pseudo-elemento forza la altura, manteniendo la relación 696/712 ≈ 0.977 */
.diagram-container::before {
    content: "";
    display: block;
    padding-top: calc(712 / 696 * 100%);
    /* ~102.29% */
}

.background-svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
}

.background-svg svg {
    width: 100%;
    height: 100%;
}

.content-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    pointer-events: none;
}

.branches-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

/* Ramas izquierda y derecha */
.branch {
    position: absolute;
    top: 0;
    width: 50%;
    height: 100%;
}

.left-branch {
    left: 0;
}

.right-branch {
    right: 0;
}

/* Cajas con las etiquetas (IndicatorCard) */
.box {
    position: absolute;
    display: flex;
    align-items: center;
    gap: 0.625rem;
    transition: all 0.3s ease;
    transform-origin: center;
    pointer-events: auto;
}

.box:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(54, 190, 184, 0.15);
}

/* Posiciones “fijas” en % dentro del contenedor */
.box-neurotoxicos {
    top: 2%;
    left: 35%;
    z-index: 10;
}

.box-lesiones {
    top: 20%;
    left: 20%;
}

.box-afectaciones {
    top: 39%;
    left: 17%;
}

.box-toxicidad {
    top: 56%;
    left: 20%;
}

.box-reproductivos {
    top: 76%;
    left: 23%;
}

.box-ototoxicos {
    top: 20%;
    right: 20%;
}

.box-ingestion {
    top: 39%;
    right: 17%;
}

.box-mutagen {
    top: 56%;
    right: 20%;
}

.box-irritacion {
    top: 76%;
    right: 23%;
}

/* MEDIA QUERIES: Ajustes de escalado en pantallas pequeñas */
@media (max-width: 768px) {
    .box {
        padding: 0.5rem 0.75rem;
        transform: scale(0.9);
    }

    .left-branch .box {
        transform-origin: left center;
    }

    .right-branch .box {
        transform-origin: right center;
    }
}

@media (max-width: 480px) {
    .box {
        padding: 0.375rem 0.625rem;
        transform: scale(0.8);
    }

    /* Si necesitas mover un poco la caja superior (Neurotóxicos) para que no se salga,
     puedes ajustarle un “translateX” o la posición top/left con un extra */
    .box-neurotoxicos {
        transform: translateX(-15%) scale(0.8);
    }

    /* Ajusta un poco los márgenes left/right para evitar que se salgan los “brazos” */
    .left-branch .box {
        left: 5%;
    }

    .right-branch .box {
        right: 5%;
    }
}
</style>
